import CaseInitialConditions from './CaseInitialConditions.vue';

export default CaseInitialConditions;
